// This component allows to change the size and color for icons and also allows us to add classNames for wrapper

/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';

const IconWrapper = (props) => {
  return (
    <div
      {...props}
    />
  );
};

export const ThreeDots = ({
  color = 'currentColor', width = 16, height = 4, ...rest
}) => {
  // icon is rectangle
  return (
    <IconWrapper {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 4" fill="none">
        <path d="M2 4C1.45 4 0.979167 3.80417 0.5875 3.4125C0.195833 3.02083 0 2.55 0 2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0C2.55 0 3.02083 0.195833 3.4125 0.5875C3.80417 0.979167 4 1.45 4 2C4 2.55 3.80417 3.02083 3.4125 3.4125C3.02083 3.80417 2.55 4 2 4ZM8 4C7.45 4 6.97917 3.80417 6.5875 3.4125C6.19583 3.02083 6 2.55 6 2C6 1.45 6.19583 0.979167 6.5875 0.5875C6.97917 0.195833 7.45 0 8 0C8.55 0 9.02083 0.195833 9.4125 0.5875C9.80417 0.979167 10 1.45 10 2C10 2.55 9.80417 3.02083 9.4125 3.4125C9.02083 3.80417 8.55 4 8 4ZM14 4C13.45 4 12.9792 3.80417 12.5875 3.4125C12.1958 3.02083 12 2.55 12 2C12 1.45 12.1958 0.979167 12.5875 0.5875C12.9792 0.195833 13.45 0 14 0C14.55 0 15.0208 0.195833 15.4125 0.5875C15.8042 0.979167 16 1.45 16 2C16 2.55 15.8042 3.02083 15.4125 3.4125C15.0208 3.80417 14.55 4 14 4Z" fill={color} />
      </svg>
    </IconWrapper>
  );
};

ThreeDots.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const ExpandDown = ({
  color = 'currentColor', width = 24, height = 24, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
        <path d="M12 15.3751L6 9.3751L7.4 7.9751L12 12.5751L16.6 7.9751L18 9.3751L12 15.3751Z" fill={color} />
      </svg>
    </IconWrapper>
  );
};

ExpandDown.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const ExpandUp = ({
  color = 'currentColor', width = 24, height = 24, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
        <path d="M7.4 15.375L6 13.975L12 7.97501L18 13.975L16.6 15.375L12 10.775L7.4 15.375Z" fill={color} />
      </svg>
    </IconWrapper>
  );
};

ExpandUp.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const SearchIcon = ({
  color = 'currentColor', width = 24, height = 24, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
        <path d="M16.3333 17.5L11.0833 12.25C10.6667 12.5833 10.1875 12.8472 9.64583 13.0417C9.10417 13.2361 8.52778 13.3333 7.91667 13.3333C6.40278 13.3333 5.12153 12.809 4.07292 11.7604C3.02431 10.7118 2.5 9.43056 2.5 7.91667C2.5 6.40278 3.02431 5.12153 4.07292 4.07292C5.12153 3.02431 6.40278 2.5 7.91667 2.5C9.43056 2.5 10.7118 3.02431 11.7604 4.07292C12.809 5.12153 13.3333 6.40278 13.3333 7.91667C13.3333 8.52778 13.2361 9.10417 13.0417 9.64583C12.8472 10.1875 12.5833 10.6667 12.25 11.0833L17.5 16.3333L16.3333 17.5ZM7.91667 11.6667C8.95833 11.6667 9.84375 11.3021 10.5729 10.5729C11.3021 9.84375 11.6667 8.95833 11.6667 7.91667C11.6667 6.875 11.3021 5.98958 10.5729 5.26042C9.84375 4.53125 8.95833 4.16667 7.91667 4.16667C6.875 4.16667 5.98958 4.53125 5.26042 5.26042C4.53125 5.98958 4.16667 6.875 4.16667 7.91667C4.16667 8.95833 4.53125 9.84375 5.26042 10.5729C5.98958 11.3021 6.875 11.6667 7.91667 11.6667Z" fill={color} />
      </svg>
    </IconWrapper>
  );
};

SearchIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const RouteIcon = ({
  color = 'currentColor', width = 20, height = 20, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
        <path d="M7.5 17.5C6.58333 17.5 5.79861 17.1736 5.14583 16.5208C4.49306 15.8681 4.16667 15.0833 4.16667 14.1667V7.35417C3.68056 7.17361 3.28125 6.87153 2.96875 6.44792C2.65625 6.02431 2.5 5.54167 2.5 5C2.5 4.30556 2.74306 3.71528 3.22917 3.22917C3.71528 2.74306 4.30556 2.5 5 2.5C5.69444 2.5 6.28472 2.74306 6.77083 3.22917C7.25694 3.71528 7.5 4.30556 7.5 5C7.5 5.54167 7.34375 6.02431 7.03125 6.44792C6.71875 6.87153 6.31944 7.17361 5.83333 7.35417V14.1667C5.83333 14.625 5.99653 15.0174 6.32292 15.3438C6.64931 15.6701 7.04167 15.8333 7.5 15.8333C7.95833 15.8333 8.35069 15.6701 8.67708 15.3438C9.00347 15.0174 9.16667 14.625 9.16667 14.1667V5.83333C9.16667 4.91667 9.49306 4.13194 10.1458 3.47917C10.7986 2.82639 11.5833 2.5 12.5 2.5C13.4167 2.5 14.2014 2.82639 14.8542 3.47917C15.5069 4.13194 15.8333 4.91667 15.8333 5.83333V12.6458C16.3194 12.8264 16.7188 13.1285 17.0312 13.5521C17.3438 13.9757 17.5 14.4583 17.5 15C17.5 15.6944 17.2569 16.2847 16.7708 16.7708C16.2847 17.2569 15.6944 17.5 15 17.5C14.3056 17.5 13.7153 17.2569 13.2292 16.7708C12.7431 16.2847 12.5 15.6944 12.5 15C12.5 14.4583 12.6562 13.9722 12.9688 13.5417C13.2812 13.1111 13.6806 12.8125 14.1667 12.6458V5.83333C14.1667 5.375 14.0035 4.98264 13.6771 4.65625C13.3507 4.32986 12.9583 4.16667 12.5 4.16667C12.0417 4.16667 11.6493 4.32986 11.3229 4.65625C10.9965 4.98264 10.8333 5.375 10.8333 5.83333V14.1667C10.8333 15.0833 10.5069 15.8681 9.85417 16.5208C9.20139 17.1736 8.41667 17.5 7.5 17.5ZM5 5.83333C5.23611 5.83333 5.43403 5.75347 5.59375 5.59375C5.75347 5.43403 5.83333 5.23611 5.83333 5C5.83333 4.76389 5.75347 4.56597 5.59375 4.40625C5.43403 4.24653 5.23611 4.16667 5 4.16667C4.76389 4.16667 4.56597 4.24653 4.40625 4.40625C4.24653 4.56597 4.16667 4.76389 4.16667 5C4.16667 5.23611 4.24653 5.43403 4.40625 5.59375C4.56597 5.75347 4.76389 5.83333 5 5.83333ZM15 15.8333C15.2361 15.8333 15.434 15.7535 15.5938 15.5938C15.7535 15.434 15.8333 15.2361 15.8333 15C15.8333 14.7639 15.7535 14.566 15.5938 14.4062C15.434 14.2465 15.2361 14.1667 15 14.1667C14.7639 14.1667 14.566 14.2465 14.4062 14.4062C14.2465 14.566 14.1667 14.7639 14.1667 15C14.1667 15.2361 14.2465 15.434 14.4062 15.5938C14.566 15.7535 14.7639 15.8333 15 15.8333Z" fill={color} />
      </svg>
    </IconWrapper>
  );
};

RouteIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const Plus = ({
  color = 'currentColor', width = 14, height = 14, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14" fill="none">
        <path d="M6 8H0V6H6V0H8V6H14V8H8V14H6V8Z" fill={color} />
      </svg>
    </IconWrapper>
  );
};

Plus.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const AppsRounded = ({
  color = 'currentColor', width = 24, height = 24, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
        <path
          d="M6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18C4 17.45 4.19583 16.9792 4.5875 16.5875C4.97917 16.1958 5.45 16 6 16C6.55 16 7.02083 16.1958 7.4125 16.5875C7.80417 16.9792 8 17.45 8 18C8 18.55 7.80417 19.0208 7.4125 19.4125C7.02083 19.8042 6.55 20 6 20ZM12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM18 20C17.45 20 16.9792 19.8042 16.5875 19.4125C16.1958 19.0208 16 18.55 16 18C16 17.45 16.1958 16.9792 16.5875 16.5875C16.9792 16.1958 17.45 16 18 16C18.55 16 19.0208 16.1958 19.4125 16.5875C19.8042 16.9792 20 17.45 20 18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20ZM6 14C5.45 14 4.97917 13.8042 4.5875 13.4125C4.19583 13.0208 4 12.55 4 12C4 11.45 4.19583 10.9792 4.5875 10.5875C4.97917 10.1958 5.45 10 6 10C6.55 10 7.02083 10.1958 7.4125 10.5875C7.80417 10.9792 8 11.45 8 12C8 12.55 7.80417 13.0208 7.4125 13.4125C7.02083 13.8042 6.55 14 6 14ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM18 14C17.45 14 16.9792 13.8042 16.5875 13.4125C16.1958 13.0208 16 12.55 16 12C16 11.45 16.1958 10.9792 16.5875 10.5875C16.9792 10.1958 17.45 10 18 10C18.55 10 19.0208 10.1958 19.4125 10.5875C19.8042 10.9792 20 11.45 20 12C20 12.55 19.8042 13.0208 19.4125 13.4125C19.0208 13.8042 18.55 14 18 14ZM6 8C5.45 8 4.97917 7.80417 4.5875 7.4125C4.19583 7.02083 4 6.55 4 6C4 5.45 4.19583 4.97917 4.5875 4.5875C4.97917 4.19583 5.45 4 6 4C6.55 4 7.02083 4.19583 7.4125 4.5875C7.80417 4.97917 8 5.45 8 6C8 6.55 7.80417 7.02083 7.4125 7.4125C7.02083 7.80417 6.55 8 6 8ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8ZM18 8C17.45 8 16.9792 7.80417 16.5875 7.4125C16.1958 7.02083 16 6.55 16 6C16 5.45 16.1958 4.97917 16.5875 4.5875C16.9792 4.19583 17.45 4 18 4C18.55 4 19.0208 4.19583 19.4125 4.5875C19.8042 4.97917 20 5.45 20 6C20 6.55 19.8042 7.02083 19.4125 7.4125C19.0208 7.80417 18.55 8 18 8Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};

AppsRounded.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const CompletedTrue = ({
  color = 'currentColor', width = 24, height = 24, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
        <path
          d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};

CompletedTrue.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const CompletedFalse = ({
  color = 'currentColor', width = 24, height = 24, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
        <path
          d="M8.4 17L12 13.4L15.6 17L17 15.6L13.4 12L17 8.4L15.6 7L12 10.6L8.4 7L7 8.4L10.6 12L7 15.6L8.4 17ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};

CompletedFalse.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const ArrowRight = ({
  color = 'currentColor', width = 18, height = 18, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 18" fill="none">
        <path
          d="M12.1313 9.75H3V8.25H12.1313L7.93125 4.05L9 3L15 9L9 15L7.93125 13.95L12.1313 9.75Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};

ArrowRight.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const EditTabs = ({
  color = 'currentColor', width = 24, height = 24, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
        <path
          d="M5 19H6.425L16.2 9.225L14.775 7.8L5 17.575V19ZM3 21V16.75L16.2 3.575C16.4 3.39167 16.6208 3.25 16.8625 3.15C17.1042 3.05 17.3583 3 17.625 3C17.8917 3 18.15 3.05 18.4 3.15C18.65 3.25 18.8667 3.4 19.05 3.6L20.425 5C20.625 5.18333 20.7708 5.4 20.8625 5.65C20.9542 5.9 21 6.15 21 6.4C21 6.66667 20.9542 6.92083 20.8625 7.1625C20.7708 7.40417 20.625 7.625 20.425 7.825L7.25 21H3ZM15.475 8.525L14.775 7.8L16.2 9.225L15.475 8.525Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};

EditTabs.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

// This is a close icon "x" which is typically used in Modals
export const CloseIcon = ({
  color = 'currentColor', width = 32, height = 32, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32" fill="none">
        <path
          d="M11.1999 22.6662L9.33325 20.7995L14.1333 15.9995L9.33325 11.2329L11.1999 9.36621L15.9999 14.1662L20.7666 9.36621L22.6333 11.2329L17.8333 15.9995L22.6333 20.7995L20.7666 22.6662L15.9999 17.8662L11.1999 22.6662Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};

CloseIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const CloseToastIcon = ({
  color = 'currentColor', width = 14, height = 14, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14" fill="none">
        <path
          d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};

CloseToastIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const DndDropIcon = ({
  color = 'currentColor', width = 14, height = 14, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14" fill="none">
        <path
          d="M5.25001 11.6663C4.92918 11.6663 4.65452 11.5521 4.42605 11.3236C4.19758 11.0952 4.08334 10.8205 4.08334 10.4997C4.08334 10.1788 4.19758 9.90419 4.42605 9.67572C4.65452 9.44724 4.92918 9.33301 5.25001 9.33301C5.57084 9.33301 5.8455 9.44724 6.07397 9.67572C6.30244 9.90419 6.41668 10.1788 6.41668 10.4997C6.41668 10.8205 6.30244 11.0952 6.07397 11.3236C5.8455 11.5521 5.57084 11.6663 5.25001 11.6663ZM8.75001 11.6663C8.42918 11.6663 8.15452 11.5521 7.92605 11.3236C7.69758 11.0952 7.58334 10.8205 7.58334 10.4997C7.58334 10.1788 7.69758 9.90419 7.92605 9.67572C8.15452 9.44724 8.42918 9.33301 8.75001 9.33301C9.07084 9.33301 9.3455 9.44724 9.57397 9.67572C9.80244 9.90419 9.91668 10.1788 9.91668 10.4997C9.91668 10.8205 9.80244 11.0952 9.57397 11.3236C9.3455 11.5521 9.07084 11.6663 8.75001 11.6663ZM5.25001 8.16634C4.92918 8.16634 4.65452 8.05211 4.42605 7.82363C4.19758 7.59516 4.08334 7.32051 4.08334 6.99967C4.08334 6.67884 4.19758 6.40419 4.42605 6.17572C4.65452 5.94724 4.92918 5.83301 5.25001 5.83301C5.57084 5.83301 5.8455 5.94724 6.07397 6.17572C6.30244 6.40419 6.41668 6.67884 6.41668 6.99967C6.41668 7.32051 6.30244 7.59516 6.07397 7.82363C5.8455 8.05211 5.57084 8.16634 5.25001 8.16634ZM8.75001 8.16634C8.42918 8.16634 8.15452 8.05211 7.92605 7.82363C7.69758 7.59516 7.58334 7.32051 7.58334 6.99967C7.58334 6.67884 7.69758 6.40419 7.92605 6.17572C8.15452 5.94724 8.42918 5.83301 8.75001 5.83301C9.07084 5.83301 9.3455 5.94724 9.57397 6.17572C9.80244 6.40419 9.91668 6.67884 9.91668 6.99967C9.91668 7.32051 9.80244 7.59516 9.57397 7.82363C9.3455 8.05211 9.07084 8.16634 8.75001 8.16634ZM5.25001 4.66634C4.92918 4.66634 4.65452 4.55211 4.42605 4.32363C4.19758 4.09516 4.08334 3.82051 4.08334 3.49967C4.08334 3.17884 4.19758 2.90419 4.42605 2.67572C4.65452 2.44724 4.92918 2.33301 5.25001 2.33301C5.57084 2.33301 5.8455 2.44724 6.07397 2.67572C6.30244 2.90419 6.41668 3.17884 6.41668 3.49967C6.41668 3.82051 6.30244 4.09516 6.07397 4.32363C5.8455 4.55211 5.57084 4.66634 5.25001 4.66634ZM8.75001 4.66634C8.42918 4.66634 8.15452 4.55211 7.92605 4.32363C7.69758 4.09516 7.58334 3.82051 7.58334 3.49967C7.58334 3.17884 7.69758 2.90419 7.92605 2.67572C8.15452 2.44724 8.42918 2.33301 8.75001 2.33301C9.07084 2.33301 9.3455 2.44724 9.57397 2.67572C9.80244 2.90419 9.91668 3.17884 9.91668 3.49967C9.91668 3.82051 9.80244 4.09516 9.57397 4.32363C9.3455 4.55211 9.07084 4.66634 8.75001 4.66634Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};

DndDropIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const TrashIcon = ({
  color = 'currentColor', width = 24, height = 24, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width={width} height={height} />
        <path
          d="M9.67079 16.5L12.3457 13.9L15.0206 16.5L16.4609 15.1L13.786 12.5L16.4609 9.9L15.0206 8.5L12.3457 11.1L9.67079 8.5L8.23046 9.9L10.9054 12.5L8.23046 15.1L9.67079 16.5ZM7.20165 21C6.63581 21 6.15141 20.8042 5.74846 20.4125C5.34552 20.0208 5.14404 19.55 5.14404 19V6H4.11523V4H9.25927V3H15.4321V4H20.5761V6H19.5473V19C19.5473 19.55 19.3459 20.0208 18.9429 20.4125C18.54 20.8042 18.0556 21 17.4897 21H7.20165ZM17.4897 6H7.20165V19H17.4897V6Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};

TrashIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const TagNameIcon = ({
  color = 'currentColor', ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.94118 16.49C7.6408 16.83 7.28411 17 6.87109 17C6.45807 17 6.10138 16.83 5.801 16.49L0.43179 10.4125C0.14393 10.0867 0 9.68646 0 9.21188C0 8.73729 0.14393 8.33708 0.43179 8.01125L7.04005 0.51C7.17772 0.354167 7.34043 0.230208 7.52816 0.138125C7.7159 0.0460417 7.91615 0 8.12891 0H13.4981C13.9111 0 14.2647 0.166458 14.5588 0.499375C14.8529 0.832292 15 1.2325 15 1.7V7.7775C15 8.01833 14.9593 8.245 14.878 8.4575C14.7966 8.67 14.6871 8.85417 14.5494 9.01L7.94118 16.49ZM11.6208 5.1C11.9337 5.1 12.1996 4.97604 12.4186 4.72813C12.6377 4.48021 12.7472 4.17917 12.7472 3.825C12.7472 3.47083 12.6377 3.16979 12.4186 2.92188C12.1996 2.67396 11.9337 2.55 11.6208 2.55C11.3079 2.55 11.0419 2.67396 10.8229 2.92188C10.6039 3.16979 10.4944 3.47083 10.4944 3.825C10.4944 4.17917 10.6039 4.48021 10.8229 4.72813C11.0419 4.97604 11.3079 5.1 11.6208 5.1ZM6.87109 15.3L13.4981 7.7775V1.7H8.12891L1.50188 9.2225L6.87109 15.3Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};

TagNameIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const GreenCheckIcon = ({
  width = 24, height = 24, ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_6583_22222" maskUnits="userSpaceOnUse" x="0" y="0" width={width} height={height}>
          <rect width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_6583_22222)">
          <path d="M10.6 16.6L17.65 9.55L16.25 8.15L10.6 13.8L7.75 10.95L6.35 12.35L10.6 16.6ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#44AC5C" />
        </g>
      </svg>
    </IconWrapper>
  );
};

GreenCheckIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const AdminIcon = ({
  color = 'currentColor', width = 24, height = 24, className = '', ...rest
}) => {
  return (
    <IconWrapper {...rest}>
      <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <g id="admin">
          <path
            id="shield_person"
            d="M12 13C11.0167 13 10.1875 12.6625 9.5125 11.9875C8.8375 11.3125 8.5 10.4833 8.5 9.5C8.5 8.51667 8.8375 7.6875 9.5125 7.0125C10.1875 6.3375 11.0167 6 12 6C12.9833 6 13.8125 6.3375 14.4875 7.0125C15.1625 7.6875 15.5 8.51667 15.5 9.5C15.5 10.4833 15.1625 11.3125 14.4875 11.9875C13.8125 12.6625 12.9833 13 12 13ZM12 11C12.4333 11 12.7917 10.8583 13.075 10.575C13.3583 10.2917 13.5 9.93333 13.5 9.5C13.5 9.06667 13.3583 8.70833 13.075 8.425C12.7917 8.14167 12.4333 8 12 8C11.5667 8 11.2083 8.14167 10.925 8.425C10.6417 8.70833 10.5 9.06667 10.5 9.5C10.5 9.93333 10.6417 10.2917 10.925 10.575C11.2083 10.8583 11.5667 11 12 11ZM12 22C9.68333 21.4167 7.77083 20.0875 6.2625 18.0125C4.75417 15.9375 4 13.6333 4 11.1V5L12 2L20 5V11.1C20 13.6333 19.2458 15.9375 17.7375 18.0125C16.2292 20.0875 14.3167 21.4167 12 22ZM12 4.125L6 6.375V11.1C6 12 6.125 12.875 6.375 13.725C6.625 14.575 6.96667 15.375 7.4 16.125C8.1 15.775 8.83333 15.5 9.6 15.3C10.3667 15.1 11.1667 15 12 15C12.8333 15 13.6333 15.1 14.4 15.3C15.1667 15.5 15.9 15.775 16.6 16.125C17.0333 15.375 17.375 14.575 17.625 13.725C17.875 12.875 18 12 18 11.1V6.375L12 4.125ZM12 17C11.4 17 10.8167 17.0667 10.25 17.2C9.68333 17.3333 9.14167 17.5167 8.625 17.75C9.10833 18.25 9.63333 18.6833 10.2 19.05C10.7667 19.4167 11.3667 19.7 12 19.9C12.6333 19.7 13.2333 19.4167 13.8 19.05C14.3667 18.6833 14.8917 18.25 15.375 17.75C14.8583 17.5167 14.3167 17.3333 13.75 17.2C13.1833 17.0667 12.6 17 12 17Z"
            fill={color}
          />
        </g>
      </svg>
    </IconWrapper>
  );
};

AdminIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
};

export const CollapseIcon = ({
  color = 'currentColor', width = 18, height = 18, ...rest
}) => {
  return (
    <IconWrapper {...rest}>

      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 18" fill="none">
        <path
          d="M9 11.5305L4.5 7.03047L5.55 5.98047L9 9.43047L12.45 5.98047L13.5 7.03047L9 11.5305Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};

CollapseIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const GroceryIcon = ({
  color = 'currentColor', width = 18, height = 18, ...rest
}) => {
  return (
    <IconWrapper {...rest}>

      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 20" fill="none">
        <path
          d="M16 22C14.3333 22 12.9167 21.4167 11.75 20.25C10.5833 19.0833 10 17.6667 10 16C10 14.3333 10.5833 12.9167 11.75 11.75C12.9167 10.5833 14.3333 10 16 10C17.6667 10 19.0833 10.5833 20.25 11.75C21.4167 12.9167 22 14.3333 22 16C22 17.6667 21.4167 19.0833 20.25 20.25C19.0833 21.4167 17.6667 22 16 22ZM16 20C17.1 20 18.0417 19.6083 18.825 18.825C19.6083 18.0417 20 17.1 20 16C20 14.9 19.6083 13.9583 18.825 13.175C18.0417 12.3917 17.1 12 16 12C14.9 12 13.9583 12.3917 13.175 13.175C12.3917 13.9583 12 14.9 12 16C12 17.1 12.3917 18.0417 13.175 18.825C13.9583 19.6083 14.9 20 16 20ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V10.4C2 10.2667 2.0125 10.1333 2.0375 10C2.0625 9.86667 2.1 9.73333 2.15 9.6L4.15 5H4C3.71667 5 3.47917 4.90417 3.2875 4.7125C3.09583 4.52083 3 4.28333 3 4V3C3 2.71667 3.09583 2.47917 3.2875 2.2875C3.47917 2.09583 3.71667 2 4 2H11C11.2833 2 11.5208 2.09583 11.7125 2.2875C11.9042 2.47917 12 2.71667 12 3V4C12 4.28333 11.9042 4.52083 11.7125 4.7125C11.5208 4.90417 11.2833 5 11 5H10.85L12.5 8.8C12.1833 8.96667 11.8833 9.14167 11.6 9.325C11.3167 9.50833 11.05 9.71667 10.8 9.95L8.7 5H6.3L4 10.4V18H8.25C8.33333 18.35 8.44583 18.6958 8.5875 19.0375C8.72917 19.3792 8.9 19.7 9.1 20H4ZM16 9C15.3 9 14.7083 8.75833 14.225 8.275C13.7417 7.79167 13.5 7.2 13.5 6.5C13.5 5.8 13.7417 5.20833 14.225 4.725C14.7083 4.24167 15.3 4 16 4V9C16 8.3 16.2417 7.70833 16.725 7.225C17.2083 6.74167 17.8 6.5 18.5 6.5C19.2 6.5 19.7917 6.74167 20.275 7.225C20.7583 7.70833 21 8.3 21 9H16Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};

GroceryIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export const customIconsDictionary = [
  { Component: ThreeDots, label: 'Three Dots' },
  { Component: ExpandDown, label: 'Expand Down' },
  { Component: SearchIcon, label: 'Search Icon' },
  { Component: RouteIcon, label: 'Route Icon' },
  { Component: Plus, label: 'Plus' },
  { Component: AppsRounded, label: 'Apps Rounded' },
  { Component: CompletedTrue, label: 'Completed True' },
  { Component: CompletedFalse, label: 'Completed False' },
  { Component: ArrowRight, label: 'Arrow Right' },
  { Component: EditTabs, label: 'Edit Tabs' },
  { Component: CloseIcon, label: 'Close Icon' },
  { Component: DndDropIcon, label: 'Dnd Drop Icon' },
  { Component: TrashIcon, label: 'Trash Icon' },
  { Component: TagNameIcon, label: 'Tag Name Icon' },
  { Component: GreenCheckIcon, label: 'Green Check Icon' },
  { Component: AdminIcon, label: 'Admin Icon' },
  { Component: GroceryIcon, label: 'Grocery Icon' },
];
